import * as React from 'react';
import { case4CauseToastGetSalesText } from './case4CauseToastGetSalesText';
import {
  getBlackFriday,
  getCause4CauseToastPrimitives,
} from './case4CauseHelpers';

export function getC4CToastText({
  c4cCartTotal,
  qtyInCart,
  isDiscount20,
  pcPotentialSavings: pcPotentialSavingsOriginal,
  isUserPC,
  componentType,
  enrollingAsPC,
  flags,
}: any) {
  const primitives = getCause4CauseToastPrimitives({
    c4cCartTotal,
    qtyInCart,
    isUserPC,
    componentType,
    enrollingAsPC,
    isDiscount20,
  });
  const {
    isPC,
    isUpsellHeader,
    showSavingsPC,
    showSavingsNonPC,
    PCDefault,
    nonPCDefault,
    hasMaxDiscount,
  } = primitives;
  const pcPotentialSavings = Array.isArray(pcPotentialSavingsOriginal)
    ? pcPotentialSavingsOriginal[0]
    : pcPotentialSavingsOriginal;
  let toastClassName = 'ToastText';
  if (isUpsellHeader) toastClassName += ' ToastTextPCUpsell';

  let modifiedDiscounts;
  let promoText = '';

  if (getBlackFriday(flags)) {
    modifiedDiscounts = [10, 20, 35];
    // promoText = ' this month only';
  }
  const toast = case4CauseToastGetSalesText(
    qtyInCart,
    isPC,
    modifiedDiscounts,
    promoText,
    pcPotentialSavings,
    c4cCartTotal,
  );

  // const showSavingsPCText =
  //   showSavingsPC && pcPotentialSavings && pcPotentialSavings.toFixed ? (
  //     <span>${pcPotentialSavings.toFixed(2)} saved!</span>
  //   ) : (
  //     ''
  //   );

  // const showSavingsNonPCText = showSavingsNonPC
  //   ? pcPotentialSavings &&
  //     pcPotentialSavings.toFixed && (
  //       <span>
  //         <a href="/preferred">Become a</a> Preferred Customer to save $
  //         {pcPotentialSavings.toFixed(2)}
  //         !&nbsp;
  //       </span>
  //     )
  //   : '';
  // const PCDefaultText = PCDefault ? (
  //   <span className={!hasMaxDiscount ? toastClassName : 'ToastText '}>
  //     {qtyInCart === 0 ? <a href="/preferred">Preferred Customers</a> : ''}
  //     &nbsp;
  //     {toast}
  //   </span>
  // ) : (
  //   ''
  // );
  // const nonPCDefaultText = nonPCDefault ? (
  //   <span className={!hasMaxDiscount ? toastClassName : 'ToastText '}>
  //     &nbsp;
  //     <a href="/preferred">Preferred Customers</a> {toast}{' '}
  //     {qtyInCart >= 6
  //       ? pcPotentialSavings &&
  //         pcPotentialSavings.toFixed &&
  //         `$${pcPotentialSavings.toFixed(2)}!`
  //       : ''}
  //   </span>
  // ) : (
  //   ''
  // );

  return toast;
}
